import { render } from "./ProcessScreen.vue?vue&type=template&id=23271252&scoped=true"
import script from "./ProcessScreen.vue?vue&type=script&lang=js"
export * from "./ProcessScreen.vue?vue&type=script&lang=js"

import "./ProcessScreen.vue?vue&type=style&index=0&id=23271252&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23271252"]])

export default __exports__